/**
 * checkin.service.ts
 *
 * Resolves a wallet membership-card check-in token (scanned via NFC/QR by
 * staff). The backend verifies the token, auto-checks-in the patient's
 * appointment for today, and returns where to navigate — the patient's detail
 * page with the Appointments tab active.
 */
import { apiClient } from './apiClient';
import type { ApiResponse } from '@/types/api.types';

export interface CheckinResolution {
  patientID: number;
  membershipID: number;
  appointmentID: number | null;
  checkedIn: boolean;
  /** App-relative path, e.g. "/patients/123?section=appointments". */
  redirect: string;
}

export const checkinService = {
  resolve(token: string): Promise<CheckinResolution> {
    return apiClient
      .get<ApiResponse<CheckinResolution>>(`/checkin/resolve/${encodeURIComponent(token)}`)
      .then((r) => r.data.data);
  },
};
